import { Typography, Link, Container } from "@mui/material";
import Apollo from "images/wedding_party/Apollo2.jpg";

export default function TheRegistry() {
  return (
    <>
      <Typography variant="h3" color="secondary" align="center" gutterBottom>
        The Registry
      </Typography>
      <Container align="center">
        <img
          alt={"Apollo.jpg"}
          src={Apollo}
          style={{ borderRadius: 20, height: "60vh" }}
        />
      </Container>
      <Typography
        variant="h5"
        color="secondary.light"
        align="center"
        gutterBottom
      >
        Apollo has requested that all gifts come in the form of cash to put
        towards treats and toys. That being said if you are ok with
        disappointing Apollo, here is a link to our{" "}
        <Link
          href="https://www.myregistry.com/wedding-registry/megan-charron-and-niko-somos-edmonton-ab/4794181/giftlist"
          target="_blank"
          variant="h5"
          color="secondary"
        >
          registry
        </Link>
      </Typography>
    </>
  );
}
